<template>
  <div class="modal-content fm-modal-video-player">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        {{ lang.modal.videoPlayer.title }}
        <small class="text-muted pl-3">{{ videoFile.basename }}</small>
      </h5>
      <button type="button" class="close" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body d-flex align-center justify-center">
      <video
        class="fm-video"
        controls
        :src="`${storagePrefix}/${videoFile.path}`"
      />
    </div>
    <div>{{ videoFile.path }}</div>
  </div>
</template>

<script>
import modal from "../mixins/modal";
import translate from "../../../mixins/translate";

export default {
  name: "Player",
  mixins: [modal, translate],
  computed: {
    /**
     * Video file
     * @returns {*}
     */
    videoFile() {
      return this.$store.getters["fm/selectedItems"][0];
    },
    storagePrefix() {
      return this.$store.getters.getStoragePrefix;
    }
  }
};
</script>

<style lang="scss">
.fm-video {
  max-width: 100%;
  max-height: 55vh;
}
</style>
